import * as Headless from '@sail/theme-headless';
import {css, theme} from '../theme';

export const Tab = theme(Headless.Tab, [
  css({
    cursor: css.value('pointer'),
    textAlign: css.value('center'),
    position: css.value('relative'),
    whiteSpace: css.value('nowrap'),
    color: 'secondary',
    '&:focus': {
      outline: css.value('none'),
    },
    '&:hover': {
      color: 'primary',
    },
    [Headless.TabVariants.selected.true]: {
      color: 'brand',
      '&:hover': {
        color: 'brand',
      },
    },
    [Headless.TabVariants.disabled.true]: {
      '&:hover': {
        color: 'secondary',
      },
    },
    [Headless.TabVariants.fitted.true]: {
      flexGrow: css.value(1),
    },
    [Headless.TabVariants.fitted.false]: {
      marginRight: 'large',
    },
    [Headless.TabVariants.size.small]: {
      font: 'caption',
      fontWeight: 'semibold',
      paddingTop: 'xsmall',
      paddingBottom: 'xsmall',
    },
    [Headless.TabVariants.size.medium]: {
      font: 'body',
      fontWeight: 'semibold',
      paddingTop: 'medium',
      paddingBottom: 'medium',
    },
    [Headless.TabVariants.size.large]: {
      font: 'body',
      fontWeight: 'semibold',
      padding: css.value('18px 20px'),
    },
  }),
]);

export const TabDisabledOverlay = theme(Headless.TabDisabledOverlay, [
  css({
    position: css.value('absolute'),
    background: 'surface',
    opacity: css.value('0.5'),
    top: css.value('-1px'),
    bottom: css.value('-1px'),
    left: css.value('-1px'),
    right: css.value('-1px'),
    zIndex: css.value(1),
    cursor: css.value('not-allowed'),
  }),
]);

export const TabLine = theme(Headless.TabLine, [
  css({
    position: css.value('absolute'),
    bottom: 0,
    height: css.value('2px'),
    backgroundColor: css.value('$color.brand500'),
  }),
]);

export const TabList = theme(Headless.TabList, [
  css({
    layout: 'row',
    alignY: 'center',
    position: css.value('relative'),
    borderBottom: css.value('1px solid'),
    borderColor: 'neutral',

    [Headless.TabListVariants.fitted.true]: {
      justifyContent: css.value('space-around'),
    },
  }),
]);
